import requestv2 from "~/utils/http-v2";

const taskApi = {
	count : async (params) => {
		const url = 'v2/task/count';
		return await requestv2.get(url, {params});
	},
	gets : async (params) => {
		const url = `v2/task/${params.id}`;
		return await requestv2.get(url, {params});
	},
	add : async (params) => {
		const url = 'v2/task';
		return await requestv2.post(url, params);
	},
	adds : async (params) => {
		const url = 'v2/task';
		return await requestv2.post(url, params);
	},
	update : async (params) => {
		const url = `v2/task/${params.id}`;
		return await requestv2.patch(url, params);
	},
	delete : async (id) => {
		const url = `v2/task/${id}`;
		return await requestv2.delete(url);
	},
	status : async (params) => {
		const url = `v2/task/status/${params.id}`;
		return await requestv2.post(url, params);
	},
	fileUpload : async (params) => {
		const url = `v2/task/file/${params.id}`;
		return await requestv2.post(url, params, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		});
	},
	fileRemove : async (params) => {
		const url = `v2/task/file/delete/${params.id}`;
		return await requestv2.post(url, params);
	},
};

export default taskApi;